<p class="align-center">
  <img src="assets/img/spinner.gif" class="loading" alt="{{ 'app.loading' | translate }}">
</p>
